import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 72px 0 32px 0;

  ${up('sm')} {
    padding: 24px 0 34px 0;
  }
`

const Suptitle = styled.h6`
  margin-bottom: 12px;
  color: #0078c9;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  text-transform: uppercase;

  ${up('sm')} {
    margin-bottom: 14px;
    text-align: left;
  }
`

const Title = styled.h1`
  margin-bottom: 8px;
  color: #22262a;
  font-size: 23px;
  font-weight: bold;
  line-height: 38px;
  text-align: center;

  ${up('sm')} {
    margin-bottom: 10px;
    text-align: left;
    font-size: 26px;
    line-height: 37px;
  }
`

const Subtitle = styled.p`
  margin-bottom: 40px;
  color: #22262a;
  font-size: 16px;
  line-height: 24px;

  ${up('sm')} {
    line-height: 29px;
  }
`

const Ampi = styled.div`
  text-align: center;

  ${up('sm')} {
    text-align: left;
  }
`

export const Intro: ComponentType = () => (
  <Wrapper>
    <Container>
      <Row className="align-items-center">
        <Col md={10}>
          <Suptitle>Promueve tu Propiedad</Suptitle>
          <Title>Yucatán Premier es el portal de Bienes Raíces más relevante en Mérida y Yucatán</Title>
          <Subtitle>
            Desde el 2008 trabajamos activamente en el posicionamiento de este sitio web. En 2019 logramos promediar más
            de 51,000 visitas únicas al mes, ¡más que cualquier otra página en Mérida!
          </Subtitle>
          <Ampi>
            <img alt="" src="/images/ampi-logo.png" height="80px" />
          </Ampi>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
